import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import ProjectThumbnail from './ProjectThumbnail';
import './Portfolio.css';

const projects = [
  // Mobile Apps
  {
    id: 1,
    title: 'Tracking App',
    category: 'mobile',
    description: 'Live tracking application for real-time location services and monitoring.',
    platforms: ['Android'],
    links: {
      playStore: 'https://play.google.com/store/apps/details?id=com.trackingapplivetrack&hl=en'
    },
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    id: 2,
    title: 'Jagsfresh – Handpicked Groceries',
    category: 'mobile',
    description: 'Premium grocery delivery app with handpicked fresh products and seamless ordering experience.',
    platforms: ['Android'],
    links: {
      playStore: 'https://play.google.com/store/apps/details?id=com.jagsfresh.india&hl=en&gl=US'
    },
    gradient: 'linear-gradient(135deg, #00d9ff 0%, #7c3aed 100%)',
  },
  {
    id: 3,
    title: 'Uphance (formerly Stitchex)',
    category: 'mobile',
    description: 'Mobile sales platform for managing and tracking sales operations on the go.',
    platforms: ['Android', 'iOS'],
    links: {
      playStore: 'https://play.google.com/store/apps/details?id=com.stitchex&hl=en_IN&gl=US',
      appStore: 'https://apps.apple.com/us/app/stitchex-mobile-sales/id1439886336'
    },
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    id: 4,
    title: 'SchoolAppz',
    category: 'mobile',
    description: 'Comprehensive school management app connecting parents, students, and administrators.',
    platforms: ['Android', 'iOS'],
    links: {
      playStore: 'https://play.google.com/store/apps/details?id=com.genericsoftware.schoolappz&hl=en_IN&gl=US',
      appStore: 'https://apps.apple.com/in/app/schoolappz/id1523221924'
    },
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
  {
    id: 5,
    title: 'Montex Wallet',
    category: 'mobile',
    description: 'Secure digital wallet application for managing finances and transactions.',
    platforms: ['iOS', 'Android'],
    links: {
      appStore: 'https://apps.apple.com/us/app/montex-wallet/id1444709285'
    },
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  },
  {
    id: 6,
    title: 'Attune',
    category: 'mobile',
    description: 'Hearing health application providing personalized hearing solutions and support.',
    platforms: ['Android'],
    links: {
      playStore: 'https://play.google.com/store/apps/details?id=com.gnhearing.attune&hl=en_IN'
    },
    gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  },
  {
    id: 7,
    title: 'The Colors',
    category: 'mobile',
    description: 'Creative color palette and design inspiration application.',
    platforms: ['Android'],
    links: {
      playStore: 'https://play.google.com/store/apps/details?id=com.sixcolors'
    },
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
  },
  // Web Applications
  {
    id: 8,
    title: 'Incorporight',
    category: 'web',
    description: 'Business incorporation services platform with streamlined registration processes.',
    platforms: ['Web'],
    links: {
      website: 'https://incorporight.com/'
    },
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    id: 9,
    title: 'Coinbaazar',
    category: 'web',
    description: 'Cryptocurrency marketplace and trading platform with real-time market data.',
    platforms: ['Web'],
    links: {
      website: 'https://coinbaazar.com/'
    },
    gradient: 'linear-gradient(135deg, #00d9ff 0%, #7c3aed 100%)',
  },
  {
    id: 10,
    title: 'Fitelo / WellFit',
    category: 'web',
    description: 'Health and fitness platform offering personalized wellness programs and tracking.',
    platforms: ['Web'],
    links: {
      website: 'https://fitelo.co/'
    },
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    id: 11,
    title: 'Multipad',
    category: 'web',
    description: 'Multi-functional platform for productivity and collaboration tools.',
    platforms: ['Web'],
    links: {
      website: 'https://multipad.co/'
    },
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
  {
    id: 12,
    title: 'HODL Token',
    category: 'web',
    description: 'Cryptocurrency token platform with advanced trading and staking features.',
    platforms: ['Web'],
    links: {
      website: 'https://hodltoken.net/'
    },
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  },
  {
    id: 13,
    title: 'Tradedo',
    category: 'web',
    description: 'Professional trading platform with advanced analytics and market insights.',
    platforms: ['Web'],
    links: {
      website: 'https://www.tradedo.io/'
    },
    gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  },
  {
    id: 14,
    title: 'CoFynd',
    category: 'web',
    description: 'Co-working space discovery and booking platform connecting businesses with flexible workspaces.',
    platforms: ['Web'],
    links: {
      website: 'https://cofynd.com/'
    },
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
  },
  {
    id: 15,
    title: 'Bricksnwall',
    category: 'web',
    description: 'Real estate platform for property listings, searches, and transactions.',
    platforms: ['Web'],
    links: {
      website: 'https://www.bricksnwall.com'
    },
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    id: 16,
    title: 'Swisscheese Finance',
    category: 'web',
    description: 'Decentralized finance platform offering innovative DeFi solutions and services.',
    platforms: ['Web'],
    links: {
      website: 'https://swisscheese.finance/'
    },
    gradient: 'linear-gradient(135deg, #00d9ff 0%, #7c3aed 100%)',
  },
  {
    id: 17,
    title: 'Holiday Rental By Owner (HRBO)',
    category: 'web',
    description: 'Vacation rental platform connecting property owners with travelers worldwide.',
    platforms: ['Web'],
    links: {
      website: 'https://www.hrbo.com/'
    },
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    id: 18,
    title: 'Ledex Digital (NFT Marketplace)',
    category: 'web',
    description: 'NFT marketplace platform for buying, selling, and trading digital collectibles.',
    platforms: ['Web'],
    links: {
      website: '#'
    },
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
  {
    id: 19,
    title: 'Game-Sphere',
    category: 'web',
    description: 'Gaming platform and community hub for gamers and game developers.',
    platforms: ['Web'],
    links: {
      website: 'https://game-sphere.io/'
    },
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  },
];

const ProjectCard = ({ project, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  const handleLinkClick = (e, url) => {
    e.stopPropagation();
    if (url && url !== '#') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <motion.div
      ref={ref}
      className="project-card"
      layout
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={isInView ? { opacity: 1, y: 0, scale: 1 } : { opacity: 0, y: 50, scale: 0.9 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      whileHover={{ y: -10, scale: 1.02 }}
    >
      <div className="project-image">
        <ProjectThumbnail project={project} />
        <div className="project-overlay">
          <div className="project-badges">
            {project.platforms.map((platform, idx) => (
              <span key={idx} className="platform-badge">
                {platform === 'Android' && '🤖'}
                {platform === 'iOS' && '🍎'}
                {platform === 'Web' && '🌐'}
                {platform}
              </span>
            ))}
          </div>
          <div className="project-links">
            {project.links.playStore && (
              <motion.button
                className="link-button"
                onClick={(e) => handleLinkClick(e, project.links.playStore)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                title="View on Play Store"
              >
                📱 Play Store
              </motion.button>
            )}
            {project.links.appStore && (
              <motion.button
                className="link-button"
                onClick={(e) => handleLinkClick(e, project.links.appStore)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                title="View on App Store"
              >
                🍎 App Store
              </motion.button>
            )}
            {project.links.website && (
              <motion.button
                className="link-button"
                onClick={(e) => handleLinkClick(e, project.links.website)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                title="View Live Site"
              >
                🔗 Live Site
              </motion.button>
            )}
          </div>
        </div>
      </div>
      <div className="project-content">
        <h3 className="project-title">{project.title}</h3>
        <p className="project-description">{project.description}</p>
        <div className="project-platforms">
          {project.platforms.map((platform, idx) => (
            <span key={idx} className="platform-tag">
              {platform}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

const Portfolio = () => {
  const [filter, setFilter] = useState('all');
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const organizeMobileApps = (mobileProjects) => {
    // Section 1: Apps available on Both Android & iOS (top section)
    const dualPlatform = mobileProjects.filter(p => 
      p.platforms.includes('Android') && p.platforms.includes('iOS')
    );
    
    // Section 2: Apps available on Android only (below them)
    const androidOnly = mobileProjects.filter(p => 
      p.platforms.includes('Android') && !p.platforms.includes('iOS')
    );
    
    // iOS-only apps (if any)
    const iosOnly = mobileProjects.filter(p => 
      p.platforms.includes('iOS') && !p.platforms.includes('Android')
    );
    
    // Return in order: dual-platform first, then Android-only, then iOS-only
    return [...dualPlatform, ...androidOnly, ...iosOnly];
  };

  const getOrganizedProjects = () => {
    if (filter === 'all') {
      // Organize all projects: mobile apps first (organized), then web apps
      const mobileProjects = projects.filter(p => p.category === 'mobile');
      const webProjects = projects.filter(p => p.category === 'web');
      
      // Organize mobile apps: dual-platform first, then Android-only
      const organizedMobile = organizeMobileApps(mobileProjects);
      
      // Return: organized mobile apps first, then web apps
      return [...organizedMobile, ...webProjects];
    } else if (filter === 'mobile') {
      // Organize mobile apps: dual-platform (Android + iOS) first, then Android-only
      const mobileProjects = projects.filter(p => p.category === 'mobile');
      return organizeMobileApps(mobileProjects);
    } else {
      return projects.filter(p => p.category === filter);
    }
  };

  const filteredProjects = getOrganizedProjects();

  const filters = [
    { id: 'all', label: 'All' },
    { id: 'mobile', label: 'Mobile Apps' },
    { id: 'web', label: 'Web Apps' },
  ];

  return (
    <section id="portfolio" className="portfolio" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Our Portfolio</h2>
          <p className="section-subtitle">
            Explore our successful mobile apps and web applications with live demos
          </p>
        </motion.div>

        <motion.div
          className="portfolio-filters"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {filters.map((filterOption) => (
            <motion.button
              key={filterOption.id}
              className={`filter-btn ${filter === filterOption.id ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                setFilter(filterOption.id);
              }}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 500, damping: 25 }}
              style={{
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              {filterOption.label}
            </motion.button>
          ))}
        </motion.div>
        
        {((filter === 'mobile' || filter === 'all') && filteredProjects.length > 0) && (
          <>
            {filteredProjects.some(p => 
              p.category === 'mobile' && 
              p.platforms.includes('Android') && 
              p.platforms.includes('iOS')
            ) && (
              <motion.div
                className="portfolio-section-header"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <h3 className="section-subsection-title">🔵 Android + iOS Apps</h3>
              </motion.div>
            )}
          </>
        )}
        
        <motion.div
          className="portfolio-grid"
          layout
          key={filter}
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                staggerChildren: 0.05,
              },
            },
          }}
        >
          {filteredProjects.map((project, index) => {
            const isAndroidOnly = project.category === 'mobile' && 
              project.platforms.includes('Android') && !project.platforms.includes('iOS');
            
            // Check if we need to show Android-only section header
            // This happens when current project is Android-only and previous was dual-platform
            const prevProject = index > 0 ? filteredProjects[index - 1] : null;
            const prevWasDualPlatform = prevProject && 
              prevProject.category === 'mobile' &&
              prevProject.platforms.includes('Android') && 
              prevProject.platforms.includes('iOS');
            
            const showAndroidOnlyHeader = (filter === 'mobile' || filter === 'all') && 
              isAndroidOnly && 
              prevWasDualPlatform;
            
            // Check if we need to show Web Apps section header (when showing all)
            const showWebAppsHeader = filter === 'all' && 
              project.category === 'web' && 
              prevProject && 
              prevProject.category === 'mobile';
            
            return (
              <React.Fragment key={project.id}>
                {showAndroidOnlyHeader && (
                  <motion.div
                    className="portfolio-section-divider"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h3 className="section-subsection-title">🟢 Android-Only Apps</h3>
                  </motion.div>
                )}
                {showWebAppsHeader && (
                  <motion.div
                    className="portfolio-section-divider"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h3 className="section-subsection-title">🌐 Web Applications</h3>
                  </motion.div>
                )}
                <ProjectCard project={project} index={index} />
              </React.Fragment>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
